module.exports = __webpack_public_path__ + "img/video_icon07.9e49fc93.png";